<template>
    <div>
        <h1 class="mb-4 font-active">personalize your ring</h1>
        <p>
            Have a meaningful message to convey or a date to remember forever? Why not get it permanently inscribed on your engagement ring or wedding band?
            <br><br>
            Friendly Diamonds India offers FREE Engraving Service for all make-to-order and custom-made rings. Our  <NuxtLink :to="localePath({ name:'cyo-setting-list-ring'})">'Create Your Own' engagement rings </NuxtLink> allow you to add an inscription on the ring shank on the 'Complete Your Ring' page. However, a few settings may not have the option for engraving due to the ring design. Engravings can be an alphanumeric combination and ideally the length should not exceed 20 characters.
        </p>
        <h2>Returns, Resizing and Repairs of Engraved Rings</h2>
        <p>
            Due to their personalised characteristics, an amount of ₹1500 is deducted from the refund or exchange value when returning or exchanging engraved rings. In the case of <NuxtLink :to="localePath('/customer-service/ring-resizing')">ring resizing</NuxtLink>, the engraved characters may look different from the original (depending on the increase or decrease in size) and may become lighter, narrower, wider or erased altogether. Repairs to engraved rings can change the look of the engraving, depending on the nature of the repair. In this case, the ring can be re-engraved for a small fee of INR 1500. Please refer to our resizing policy for more information.
        </p>
    </div>
</template>

<script setup>
    const localePath = useLocalePath()
</script>

<style scoped>
.main_title {
    margin: 4% 0;
}
.main_title h2 {
    font-size: 40px;
    text-align: center;
}
h1{
    font-size: 32px;
    text-transform: capitalize;
}
p {
    margin-bottom: 0;
    color: #606060;
    font-size: 16px;
    font-weight: 500;
}
ul {
    margin-left: 25px;
    padding-left: 0;
}
ul li{
    color: #606060;
    font-size: 16px;
    font-weight: 500; 
}
h3, h2 {
    font-size: 21px;
    font-weight: 500;
    margin: 30px 0 20px;
}
h4{
    margin-bottom: 6px;
    color: #353535;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.5;
}
a{
    color: var(--green);
    text-decoration: underline;
}


@media(max-width: 767px){
    .main_title h2{
        font-size: 32px;
    }
    .main_title {
        margin: 13% 0 10%;
    }
    h1{
        font-size: 20px;
    }
    h3, h2{
        font-size: 18px;
    }
    p{
        font-size: 14px;
    }
    ul li {
        font-size: 14px;
    }
}
</style>